@if (data$ | async; as crtTask) {
<div id="details-container">
  <div>
    <dl>
      <dt>Alternative Title:</dt>
      <dd>
        {{ crtTask?.alternativeOrOptionalTitle }}
      </dd>
      <dt>Author:</dt>
      <dd>
        {{ crtTask?.author }}
      </dd>
      <dt>Work Type:</dt>
      <dd>
        {{ crtTask?.workType }}
      </dd>
      <dt>Other Info:</dt>
      <dd>
        {{ crtTask?.otherIdentifyingInformation }}
      </dd>
      <dt>Goods and Services:</dt>
      <dd>
        {{ crtTask?.goodsAndServices }}
      </dd>
      <dt>Customer name:</dt>
      <dd>{{ crtTask?.customerName }}</dd>
      <dt>Contact name:</dt>
      <dd>{{ crtTask?.contactName }}</dd>
      <dt>Special instructions:</dt>
      <dd>
        @for (si of crtTask?.specialInstructions; track si) {
        <p>{{ si.instructionFor }}: {{ si.instruction }}</p>
        }
      </dd>
      <dt>Translation/Acronym Meaning:</dt>
      <dd>{{ crtTask?.translationAcronymMeaning }}</dd>
      <dt>Intended Use for Title:</dt>
      <dd>{{ crtTask?.intendedUseForTitle }}</dd>
    </dl>
  </div>
</div>
}
